import { isDerivedStructureSet } from '~/domain/patient/derivedStructureSet';
import type { PatientSession } from '~/domain/session/PatientSession';

// True only for a set computed for display in this session; such a set is never sent to a backend.
export function isSessionDerivedStructureSet(
    session: PatientSession,
    structureSetUid: string
): boolean {
    const live = session.patient.structureSets.find(
        (set) => set.dicomUid === structureSetUid
    );
    return !!live && isDerivedStructureSet(live);
}
